const getCookie = (name: string) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length !== 2) return null;

  const cookieValue = parts.pop();
  if (!cookieValue) return null;

  return cookieValue.split(';').shift();
};

const getUtmCookies = () => {
  const [utmCampaign, utmSource, utmMedium, utmContent, utmTerm] = [
    'utm_campaign',
    'utm_source',
    'utm_medium',
    'utm_content',
    'utm_term',
  ].map(getCookie);

  return { utmCampaign, utmSource, utmMedium, utmContent, utmTerm };
};

export { getCookie, getUtmCookies };
